module.exports = __webpack_public_path__ + "static/media/view2.5aead3a2.jpg";